export const LeadTimeCalculatorInputError = () => {
  return <p style={{ color: "red", marginTop: "10px" }}>Invalid Postcode</p>;
};
